<template>
	<div class="process-card">
		<!-- 车商直售车源优势 -->
		<nio-image
			class="mt60"
			v-if="car.basic.business_type === 4"
			src="https://cdn-fx.nio.com/fx/second-hand-app-pkg/__cdn__/img_v3.png"
		></nio-image>
		<div
			class="mt60"
			v-sd-exp:VehicleDetailExpo="{
				page: '二手车车辆详情页',
				label_name: car.$$track_label_name,
				tag: car.$$track_tags,
				module_name: '购车流程',
				position_rank: 6,
				position_in_number: 1,
				position_in_rank: 1,
				track_sign: 'aMall.b4307.exposure.VehicleDetailExpo'
			}"
			v-sd-clk:VehicleDetailClick="{
				page: '二手车车辆详情页',
				label_name: car.$$track_label_name,
				tag: car.$$track_tags,
				module_name: '购车流程',
				button_name: '购车流程',
				position_rank: 6,
				position_in_rank: 1,
				position_in_number: 1,
				track_sign: 'aMall.b4307.click.VehicleDetailClick'
			}"
		>
			<p class="title">购车流程</p>

			<div class="process-list" :class="{ fill: processes.length > 3 }">
				<div v-for="(item, idx) in processes" class="process-item" :key="idx">
					<div class="icon-container">
						<img :src="item.icon" />
					</div>
					<div>
						<p>{{ item.title }}</p>
						<!-- <p>{{ item.subtitle }}</p> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Icon11 from '@/assets/svg/process-card/icon1-1.svg'
import Icon12 from '@/assets/svg/process-card/icon1-2.svg'
import Icon13 from '@/assets/svg/process-card/icon1-3.svg'
import Icon14 from '@/assets/svg/process-card/icon1-4.svg'

import Icon21 from '@/assets/svg/process-card/icon2-1.svg'
import Icon22 from '@/assets/svg/process-card/icon2-2.svg'
import Icon23 from '@/assets/svg/process-card/icon2-3.svg'
import Icon24 from '@/assets/svg/process-card/icon2-4.svg'
import Icon25 from '@/assets/svg/process-card/icon2-5.svg'

export default {
	name: 'ProcessCard',
	props: ['car'],
	data() {
		return {}
	},
	computed: {
		processes() {
			if (this.car.basic.business_type === 1) {
				return [
					{ icon: Icon11, title: '挑选车辆', subtitle: '了解车辆详情' },
					{ icon: Icon12, title: '安心下定', subtitle: '在线支付定金' },
					{ icon: Icon13, title: '尾款支付', subtitle: '支付剩余尾款' },
					{ icon: Icon14, title: '愉悦交付', subtitle: '绑定激活爱车' }
				]
			} else {
				return [
					{ icon: Icon21, title: '双方洽谈', subtitle: '双方交流' },
					{ icon: Icon22, title: '完成过户', subtitle: '支付并过户' },
					{ icon: Icon23, title: '提取爱车', subtitle: '交易完成' }
				]
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';
.process-card {
	.mt60 {
		margin-top: 60px;
	}
	.title {
		@include subtitle_1(1.4, 400, false);
		color: #040b29;
		margin-bottom: 30px;
	}

	.process-list {
		display: flex;
		justify-content: space-between;

		.process-item {
			display: flex;
			position: relative;
			flex-direction: column;
			align-items: center;

			&.fill {
				padding-left: 0;
				padding-right: 0;
			}

			&:not(:last-child) {
			}

			.icon-container {
				width: 24px;
				height: 24px;
				margin-bottom: 12px;
				position: relative;

				img {
					width: 100%;
					height: 100%;
				}
			}

			p:first-child {
				text-align: center;
				color: $text_primary;
				font-size: 14px;
				line-height: 17px;
			}

			// p:last-child {
			// 	margin-top: 2px;
			// 	text-align: center;
			// 	color: $text_disable;
			// 	font-size: 12px;
			// }
		}
	}
}
</style>
